import type { FormikHandlers } from 'formik';

import { VStack, Box } from '@frontend/components';

import {
  AwsCredentialsInput,
  AwsCredentialsWarning,
} from 'components/IccConnection';

type IccSetupAwsCredentialsProps = {
  isOpen: boolean;
  onChange: FormikHandlers['handleChange'];
};

const IccSetupAwsCredentials = ({
  isOpen,
  onChange,
}: IccSetupAwsCredentialsProps) => {
  return isOpen ? (
    <VStack mt={-1} ml={3} align="stretch" spacing={2}>
      <AwsCredentialsInput onChange={onChange} />
      <Box pt={1}>
        <AwsCredentialsWarning />
      </Box>
    </VStack>
  ) : null;
};

export default IccSetupAwsCredentials;
